import React from "react";
import Grid from "@material-ui/core/Grid";
import { HostContainer } from "./flyer-detail-page-tab-page-details.styles";
import { FlyerDetailPageTabPageDetailsProps } from "./flyer-detail-page-tab-page-details.props";
import { FlyerDetailPageTabPageDetailsName } from "../flyer-detail-page-tab-page-details-name/flyer-detail-page-tab-details-name.component";
import { FlyerDetailPageTabPageDetailsTemplate } from "../flyer-detail-page-tab-page-details-template/flyer-detail-page-tab-page-details-template.component";
import { FlyerDetailPageTabPageDetailsProducts } from "../flyer-detail-page-tab-page-details-products/flyer-detail-page-tab-page-details-products.component";
import { FlyerDetailPageTabPageDetailPositions } from "../flyer-detail-page-tab-page-details-positions/flyer-detail-page-tab-page-detail-positions.component";
import { FlyerDetailPageTabPageDetailsProgress } from "../flyer-detail-page-tab-page-details-progress/flyer-detail-page-tab-page-details-progress.component";
import { FlyerDetailPageTabPageMenu } from "../flyer-detail-page-tab-page-menu/flyer-detail-page-tab-page-menu.component";

export const FlyerDetailPageTabPageDetails = (props: FlyerDetailPageTabPageDetailsProps) => (
  <HostContainer>
    <Grid container={true} alignItems="center">
      <FlyerDetailPageTabPageDetailsName onClick={props.onClickPage}>
        {props.page.name}
      </FlyerDetailPageTabPageDetailsName>
      <FlyerDetailPageTabPageDetailsTemplate templateName={props.page.templateName} />
      <FlyerDetailPageTabPageDetailsProducts numberOfProducts={props.page.sumOfProducts} />
      <FlyerDetailPageTabPageDetailPositions numberOfPositions={props.page.positionCount} />
      <FlyerDetailPageTabPageDetailsProgress
        numberOfPositions={props.page.positionCount}
        positionWithoutProducts={props.page.percentageWithoutProducts}
      />
      <FlyerDetailPageTabPageMenu
        pageId={props.page.id}
        canDelete={props.canDelete}
        onDelete={props.onDeletePage}
      />
    </Grid>
  </HostContainer>
);
